// #region Imports

import { adjustHue, hexToHSL, hslToHex } from '../common';

// #endregion

/**
 * Generate an analogous color palette
 * @param baseHex
 * @param adjustment
 * @returns
 */
export function generateAnalogousPalette(baseHex: string, adjustment: number): Record<string, string> {
    const baseHSL = hexToHSL(baseHex);
    const adjustedHSL = adjustHue(baseHSL, adjustment);
    const palette: Record<string, string> = {};

    // Define the steps
    const steps = [
        0,
        50,
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900
    ];

    steps.forEach((step) => {
        let [h, s, l]: [number, number, number] = adjustedHSL;

        if (step === 0) {
            l = 1; // White
        } else {
            // Gradually decrease lightness for other steps
            l = 1 - (step / 1000);
        }

        palette[`${step}`] = hslToHex(h, s, Math.max(0, Math.min(1, l)));
    });

    return palette;
}

/**
 * Generate a single analogous color
 * @param baseHex
 * @param adjustment
 * @returns
 */
export function generateAnalogousColor(baseHex: string, adjustment: number): string {
    const baseHSL = hexToHSL(baseHex);
    const adjustedHSL = adjustHue(baseHSL, adjustment);
    const [h, s]: [number, number, number] = adjustedHSL;
    // Use step 500 lightness (0.5) to match palette base
    return hslToHex(h, s, 0.5);
}
